export const colors = {
  primary: "#034867",
  secondary: "#ffad01",
  text1: "#2d2d31",
  text2: "#525256",
};